import { render, staticRenderFns } from "./document-content.vue?vue&type=template&id=3f3036d9"
import script from "./document-content.vue?vue&type=script&setup=true&lang=ts"
export * from "./document-content.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports